import React from 'react';
import { Flex } from '../../components/common/atom/Layout';
import { Text } from '../../components/common/atom/Text';
import { SocialShareButtonBox } from '../../components/common/organism/SocialShare';
import { EventDetailTemplateWithButtons } from '../../components/common/template/EventDetailTemplate';
import * as IMAGE from '../../lib/image/event/EventReviewContestImages';
import * as PATH from '../../lib/routes/path';

const TITLE_REVIEW_CONTEST =
  '베이비페이스와 똑닮은 우리아기 인증하면 모두에게 선물이!';

export const ID_REVIEW_CONTEST = 'review-contest';

export const PERIOD_REVIEW_CONTEST = {
  startDate: '2022-12-01T00:00:00',
  endDate: '2023-03-06T00:00:00',
};

export const EVENT_HOME_BANNER_REVIEW_CONTEST = {
  id: ID_REVIEW_CONTEST,
  period: PERIOD_REVIEW_CONTEST,
  image: IMAGE.HOME_BANNER_REVIEW_CONTEST,
};

export const EVENT_BANNER_REVIEW_CONTEST = {
  id: ID_REVIEW_CONTEST,
  period: PERIOD_REVIEW_CONTEST,
  image: IMAGE.EVENT_BANNER_REVIEW_CONTEST,
};

export const EVENT_DETAIL_REVIEW_CONTEST = {
  title: TITLE_REVIEW_CONTEST,
  period: PERIOD_REVIEW_CONTEST,
  images: IMAGE.EVENT_DETAIL_REVIEW_CONTEST,
  buttons: [
    {
      image: IMAGE.EVENT_DETAIL_BUTTON_ROUTE,
      position: { top: '89.8%' },
      event: { type: 'route', path: PATH.MYPAGE_REVIEW },
    },
  ],
};

export const EVENT_COMPONENT_REVIEW_CONTEST = {
  id: ID_REVIEW_CONTEST,
  component: (
    <EventDetailTemplateWithButtons
      event={EVENT_DETAIL_REVIEW_CONTEST}
      key={ID_REVIEW_CONTEST}
    />
  ),
};

export const ReviewContestPopUp = ({ text, imageUrl, id }) => (
  <Flex column>
    <Text size={14} weight="medium" textAlign="center" lineHeight="1.25rem">
      소중한 후기를 작성해 주셔서 감사합니다.
      <br />
      <br />
      생후비교 리뷰 콘테스트에 응모 완료되었습니다.
      <br />
      SNS에 리뷰를 공유해주시면 당첨확률이 높아집니다
    </Text>
    <Flex>
      <SocialShareButtonBox
        params={{
          url: `https://www.babyface.io${PATH.REVIEW_DETAIL}/${id}`,
          title: '베이비페이스 생후비교 콘테스트 참여',
          text,
          imageUrl,
        }}
        buttons={[
          {
            title: '베이비페이스 리뷰',
            link: {
              mobileWebUrl: `https://www.babyface.io${PATH.REVIEW}`,
              webUrl: `https://www.babyface.io${PATH.REVIEW}`,
            },
          },
          {
            title: '생후비교 콘테스트',
            link: {
              mobileWebUrl: `https://www.babyface.io${PATH.EVENT_DETAIL}/${ID_REVIEW_CONTEST}`,
              webUrl: `https://www.babyface.io${PATH.EVENT_DETAIL}/${ID_REVIEW_CONTEST}`,
            },
          },
        ]}
      />
    </Flex>
  </Flex>
);
